/**
 * ShareLanding.js
 * Written by: Brian Kim
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { Card, Button } from '@minerva-analytics/pantheon';

import { ORANGE } from 'root/theme';


import Hero from '../../components/Hero';
import LoginForm from '../../components/LoginForm';
import TutorialDescription from '../../components/TutorialDescription';


import quizActions from '../../store/quiz/actions';
import userActions from '../../store/user/actions';

import quizSelectors from '../../store/quiz/selectors';
import referralUserRaw from '../../store/user/selectors/referralUser';

import {
  ShareLandingContainer,
  QuizSelect,
  ShareLandingTitle,
  ShareLandingSubtitle,
  UserName,
  InfoCard,
} from './ShareLanding.styles';

/**
 * The main screen that displays a question
 *
 */
export class ShareLanding extends Component {
  static propTypes = {
    jwt: PropTypes.string.isRequired,
    referralUser: PropTypes.object,
    quizzes: PropTypes.array,
    getQuizzes: PropTypes.func.isRequired,
    goToQuiz: PropTypes.func.isRequired,
    facebookLogin: PropTypes.func.isRequired,
    gmailLogin: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  }


  constructor(props) {
    super(props);
    this.state = {
      dropdownQuiz: null,
    };
  }

  componentDidMount() {
    const {
      getQuizzes,
    } = this.props;

    getQuizzes();
  }

  updateWidth = () => {
    this.setState({ width: __CLIENT__ ? window.innerWidth : 768 });
  }

  goToQuiz = (e) => {
    const { goToQuiz, history } = this.props;
    const quizId = parseInt(e.target.value, 10);
    goToQuiz(quizId)
      .then((url) => {
        history.push(url);
      });
  }

  goToRandomQuiz = () => {
    const { goToQuiz, quizzes, history, getQuizzes } = this.props;
    const randomId = Math.round(Math.random() * (quizzes.length - 1));
    if (quizzes.length > 0) {
      goToQuiz(quizzes[randomId].id)
        .then((url) => {
          history.push(url);
        });
    } else {
      getQuizzes();
    }
  }

  handleSelect = (v) => {
    const { quizzes } = this.props;
    const quiz = quizzes.find((c) => parseInt(v.target.value, 10) === c.id);

    if (quiz) {
      this.setState({
        dropdownQuiz: quiz,
      });
    }
  }

  goToQuizDropdown = () => {
    const { goToQuiz, history } = this.props;
    const { dropdownQuiz } = this.state;

    if (dropdownQuiz) {
      goToQuiz(dropdownQuiz.id)
        .then((url) => {
          history.push(url);
        });
    } else {
      this.goToRandomQuiz();
    }
  }

  render() {
    const { jwt, quizzes, referralUser, facebookLogin, gmailLogin } = this.props;
    const quizOptions = quizzes.map((c) => (
      {
        label: c.name,
        value: c.id,
      }));

    const name = referralUser ? referralUser.full_name : `Someone`;


    return (
      <ShareLandingContainer>
        <Helmet>
          <title>{ `Quizhive: You have been challenged` }</title>
          <meta property="og:title" content={ `You have been challenged!` } />
          <meta name="robots" content="noindex" />
        </Helmet>
        <Hero>
          <InfoCard size="small">
            <ShareLandingTitle>
              You&#39;ve Been Challenged.<br />It&#39;s Trivia Time!
            </ShareLandingTitle>
            <ShareLandingSubtitle>
              Can you beat <UserName>{ name }</UserName> in Trivia?
              <br />
              { jwt
                ? `Choose a quiz to get started!`
                : `Sign up to see how you perform`
              }
            </ShareLandingSubtitle>
            { jwt
              ? <div>
                <QuizSelect
                  color={ ORANGE }
                  items={ [{ label: `Random Quiz`, value: null }, ...quizOptions] }
                  onChange={ this.handleSelect }
                />
                <Button
                  border={ ORANGE }
                  color={ ORANGE }
                  onClick={ this.goToQuizDropdown }
                >
                  Go
                </Button>
              </div>
              : <LoginForm
                facebookLogin={ () => facebookLogin(`referral`) }
                gmailLogin={ () => gmailLogin(`referral`) }
                blankHeadline
              />
            }
          </InfoCard>
        </Hero>
        <TutorialDescription goToRandomQuiz={ this.goToRandomQuiz } />
        { !jwt
          ? <Card size="small">
            <LoginForm
              facebookLogin={ this.props.facebookLogin }
              gmailLogin={ this.props.gmailLogin }
              headlineText="Sign Up To See How You Perform Against Fellow Users!"
            />
          </Card>
          : null
        }
      </ShareLandingContainer>
    );
  }
}

export default connect((state) => {
  return {
    jwt: state.user.JWT,
    quizzes: quizSelectors.allQuizzes(state),
    selectedQuiz: quizSelectors.selectedQuiz(state),
    referralUser: referralUserRaw(state),
  };
}, {
  getQuizzes: quizActions.getQuizzes,
  goToQuiz: quizActions.goToQuiz,
  selectQuiz: quizActions.selectQuiz,
  facebookLogin: userActions.facebookLogin,
  gmailLogin: userActions.gmailLogin,
})(ShareLanding);
